<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Letter Generate Report
            </div>
            <div class="col-auto">
                <!-- <button type="button" *ngIf="this.common.PageRight.IsAdd" class="btn btn-primary" [routerLink]="['/letter/lettergenerate/add/']"
                    [disabled]="isDisabled">
                    <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Generate letter':'Loading...'}}
                </button> -->

                <button type="button" class="btn btn-outline-primary ms-1" [disabled]="isDisabled"
                    (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                    aria-controls="collapseFilter">
                    <i class="bi bi-caret-down-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Filter':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" class="mt-1">
            <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
                <div class="row mx-1">
                    <div class="col-md-4">
                        <label for="ApprovalStatus" class="form-font-label">Status</label>
                        <ng-select id="ApprovalStatus" name="ApprovalStatus" [items]="common.Status" bindLabel="Name"
                            bindValue="Value" placeholder="Status" [(ngModel)]="this.Filter.ApprovalStatus"
                            (change)="clear()">
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select status!
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label for="FromDateObj" class="form-font-label">From Date</label>
                        <div class="input-group">
                            <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                                [(ngModel)]="Filter.FromDateObj" ngbDatepicker #FromDateObj="ngbDatepicker" required
                                readonly (ngModelChange)="clear()"/>
                            <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                                type="button"></button>
                        </div>
                        <div class="invalid-feedback">
                            Please select from date!
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label for="ToDateObj" class="form-font-label">To Date</label>
                        <div class="input-group">
                            <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj"
                                [(ngModel)]="Filter.ToDateObj" ngbDatepicker #ToDateObj="ngbDatepicker" required
                                readonly (ngModelChange)="clear()"/>
                            <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()"
                                type="button"></button>
                        </div>
                        <div class="invalid-feedback">
                            Please select to date!
                        </div>
                    </div>
                </div>
                <div class="row mx-1">
                    <div class="col-md-4">
                        <label for="BranchID" class="text-label-dark">Branch</label>
                        <ng-select id="BranchID" name="BranchID" [items]="Branchs" bindLabel="BranchName"
                            bindValue="BranchMasterID" placeholder="Branch" [(ngModel)]="this.Filter.BranchId"
                            (change)="ComboLoad('Client');clear()">
                        </ng-select>
                    </div>
                    <div class="col-md-4">
                        <label for="ClientId" class="text-label-dark">Client</label>
                        <ng-select id="ClientId" name="ClientId" [items]="Clients" bindLabel="ClientGroupName"
                            bindValue="ClientGroupMasterID" placeholder="Client" [(ngModel)]="this.Filter.ClientId"
                            (change)="ComboLoad('Site');clear()">
                        </ng-select>
                    </div>
                    <div class="col-md-4">
                        <label for="SiteId" class="text-label-dark">Site</label>
                        <ng-select id="SiteId" name="SiteId" [items]="Sites" bindLabel="SiteName"
                            bindValue="SiteMasterID" placeholder="Site" [(ngModel)]="this.Filter.SiteId"
                            (change)="clear()">
                        </ng-select>
                    </div>
                </div>
                <div class="row m-1">
                </div>
                <div class="row m-1">
                    <div class="col"></div>
                    <div class="col-md-auto align-self-end">
                        <button class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-cloud-download me-2"
                                *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Apply':'Loading...'}}</button>
                    </div>
                </div>
            </form>
        </div>

        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th style="width: 150px;">Detail</th>
                        <th style="width: 100px;">Branch</th>
                        <th style="width: 150px;">Client</th>
                        <th style="width: 150px;">Document Type</th>
                        <th style="width: 150px;">Letter</th>
                        <th style="width: 150px;">Request Date</th>
                        <th style="width: 100px;">Approval Status</th>
                        <th style="width: 100px;">Approver Name</th>
                        <th style="width: 10px;">File</th>
                        <th style="width: 100px;">Acknowledgement Require</th>
                        <th style="width: 100px;">Acknowledgement Status</th>
                        <th>Acknowledgement Remark</th>
                        <th style="width: 100px;"
                            [ngClass]="{'colHide': !this.common.CompanyParameterValue.IsESignInAllowed}">eSign Status
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td>
                            <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                <div class="col-2">
                                    <img *ngIf="TableData['Photo'] != null && TableData['Photo'] != ''" mat-card-image
                                        class="userImage" [src]="common.PhotoLink(TableData['Photo'])" />
                                    <div *ngIf="TableData['Photo'] == null || TableData['Photo'] == ''"
                                        class="initial-image">
                                        <div class="image">
                                            {{common.getInitial(TableData['EmployeeName'])}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-9 userdetail">
                                    <span class="text-label-dark">{{TableData['EmployeeName']}}</span><br />
                                    <span class="text-label-light">#{{TableData['EmpCode']}}</span><br />
                                    <span class="text-label-light">{{TableData['DesignationName']}}</span>
                                </div>
                            </div>
                        </td>
                        <td style="width: 100px;">
                            <div style="width: 100px;">{{TableData['BranchName']}}</div>
                        </td>
                        <td style="width: 150px;">
                            <div style="width: 150px;">{{TableData['ClientLocation']}}</div>
                        </td>
                        <td style="width: 150px;">
                            <div style="width: 150px;">{{TableData['LetterDocumentTypeCode']}} -
                                {{TableData['LetterDocumentTypeName']}}</div>
                        </td>
                        <td style="width: 150px;">
                            <div style="width: 150px;">{{TableData['LetterCode']}} - {{TableData['LetterName']}}</div>
                        </td>
                        <td style="width: 150px;">
                            <div style="width: 150px;">{{TableData['RequestDate']}}</div>
                        </td>
                        <td style="width: 100px;">
                            <span class="badge"
                                [ngClass]="{'success': common.ToLowerCase(TableData['ApprovalStatus']) == 'approved', 'danger':common.ToLowerCase(TableData['ApprovalStatus']) == 'rejected','warning':(common.ToLowerCase(TableData['ApprovalStatus']) == 'pending' || common.ToLowerCase(TableData['ApprovalStatus']) == 'initiated')}">{{TableData['ApprovalStatus']}}</span>
                        </td>
                        <td style="width: 100px;">
                            <div style="width: 150px;">{{common.ToLowerCase(TableData['ApprovalStatus']) ==
                                'approved'?TableData['ApproverName']:common.ToLowerCase(TableData['ApprovalStatus']) ==
                                'rejected'?TableData['RejecterName']:TableData['PendingName']}}</div>
                        </td>
                        <td style="text-align: -webkit-center;width: 10px;">
                            <div style="width: 10px;"><a
                                    *ngIf="TableData['LetterGenerationFileName'] != '' && TableData['LetterGenerationFileName'] != null"
                                    [href]="Link(TableData['LetterCode'] + '/' + TableData['LetterGenerationFileName'])"
                                    target="_blank" class="bi bi-file-earmark-check  text-primary"
                                    style="-webkit-text-stroke: 1px"></a>
                            </div>
                        </td>
                        <td style="width: 100px;">
                            <div style="width: 100px;">{{TableData['EMPAcknowledgement']?'Yes':'No'}}</div>
                        </td>
                        <td style="width: 100px;">
                            <span class="badge"
                                [ngClass]="{'success': common.ToLowerCase(TableData['EmployeeApprovalStatus']) == 'approved', 'danger':common.ToLowerCase(TableData['EmployeeApprovalStatus']) == 'rejected','warning':common.ToLowerCase(TableData['EmployeeApprovalStatus']) == 'pending'}">{{TableData['EmployeeApprovalStatus']}}</span>
                        </td>
                        <td>{{TableData['EmployeeRemarks']}}</td>
                        <td style="width: 100px;"
                            [ngClass]="{'colHide': !this.common.CompanyParameterValue.IsESignInAllowed}">
                            <span class="badge"
                                [ngClass]="{'success': common.ToLowerCase(TableData['ESignInStatus']) == 'verified', 'danger':common.ToLowerCase(TableData['ESignInStatus']) == 'rejected','warning':common.ToLowerCase(TableData['ESignInStatus']) == 'pending'}">{{TableData['ESignInStatus']}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button (click)="excelDownload()" class="btn btn-primary btn-sm">
                    <i class="bi bi-file-earmark-arrow-down"></i>
                    Excel</button>
            </div>
        </div>
    </div>
</div>